export const SEARCH_TABS = {
  ALL: "all",
  PROFILES: "profiles",
  HASHTAGS: "hashtags",
  CHALLENGES: "challenges",
  VIDEOS: "videos",
};

export const EVENTS = {
  VIEW_IMPRESSION: "view_click",
  CONTENT_REPLAY: "video_replay",
  CONTENT_PLAY: "video_play",
  CONTENT_STOP_PLAY: "video_Stop_Play",
  CONTENT_LIKE: "content_like",
  CONTENT_UNLIKE: "content_unlike",
  CONTENT_SHARE: "content_share",
  CONTENT_PAUSE: "video_pause",
  CONTENT_RESUME: "video_resume",
  THUMBNAIL_CLICK: "thumbnail_click",
  CONTENT_VIEW: "view",
  CONTENT_ENDED: "seriesEnded",
};

export const CONTENT_TYPE = {
  VIDEO: "video",
  CHALLENGE: "challenge",
  PROFILE: "profile",
  ACTIVITY: "activity",
  HASHTAG: "hashtag",
  SHARE: "share",
  SOUND: "sound",
  SERIES: "series"
};

export const TOAST_TYPES = {
  SUCCESS: "success",
  ERROR: "error",
  INFO: "info",
};

export const STATUS = {
  VIDEO_ALREADY_REPOSTED: "VIDEO_ALREADY_REPOSTED",
};

export const PAGE = {
  FEED: "feed",
  PROFILE: "profile",
  DISCOVER: "discover",
};

export const FONTS = ["Arial", "Roboto", "NotoSans", "Poppins"];
